module.exports = __webpack_public_path__ + "static/media/eye.3c2be6e7.svg";